
/*
 * Date: 2025
 * Description: This middleware should be used for any request that needs an authenticated access to the API
 * Author: Philippe Leroux @ SKITSC
 */

//Constants
import { lexique } from "../utils/constant"

const validateEmail = ( email : string ) : boolean => {
    return lexique.email_regex.test(email)
}
const validateOptEmail = ( email : string ) : boolean => {
    if(email && email !== '') return lexique.email_regex.test(email)
    return true;
}
const validatePassword = ( password : string ) : boolean => {
    return lexique.password_regex.test(password)
}
const validateOptPassword = ( password : string ) : boolean => {
    if(password && password !== '') return lexique.password_regex.test(password)
    return true;
}
const validateUsername = ( str : any ) : boolean => {
    return lexique.str_regex.test(str)
}

const validateStr = ( str : any ) : boolean => {
    return lexique.str_regex.test(str)
}

const validateUserType = ( value : string ) : boolean => {
    if(value === 'admin' || value === 'user') return true
    return false
}
const validateEmpty = ( value : any ) : boolean => {
   if(value.length === 0) return false
   return true
}

export { validateEmail , validateOptEmail , validatePassword , validateOptPassword , validateUsername , validateStr , validateUserType , validateEmpty }